<template>
  <v-card>
    <v-card-title class>
      <span class="headline ml-2">{{ itemToEdit ? 'Editar Usuario' : 'Nuevo Usuario' }}</span>
    </v-card-title>
    <v-card-text class="pb-0">
      <v-form class="pa-0" ref="form" lazy-validation>
        <v-row>
          <v-col cols="12" sm="6" class="py-0">
            <v-text-field required :rules="rules" v-model="editedItem.username" label="Username"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <v-text-field v-model="editedItem.password"
              :label="itemToEdit ? 'Cambiar contraseña ' : 'Contraseña'"></v-text-field>
          </v-col>
          <v-col cols="6" class="py-0 d-flex align-center">
            <v-checkbox class="mr-2" v-model="editedItem.isEditor" label="Editor"></v-checkbox>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" small dark v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Puede leer y editar todo</span>
            </v-tooltip>
          </v-col>
          <v-col cols="6" sm="6" class="py-0 d-flex align-center">
            <v-checkbox dense class="mr-2" v-model="editedItem.isSupervisor" label="Supervisor"></v-checkbox>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small color="primary" dark v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Puede ver todo, pero no puded hacer cambios</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-col cols="12" sm="12" class="pa-0">
          <v-textarea filled label="Comentarios" rows="2" auto-grow dense no-resize v-model="editedItem.comment" />
        </v-col>
      </v-form>
    </v-card-text>

    <v-card-actions class="pt-0">
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="onClose">Cancel</v-btn>
      <v-btn color="blue darken-1" text @click="onSave">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { userService } from '@/services/userService.js'
export default {
  props: {
    itemToEdit: Object
  },
  created() {
    this.setUserToEdit()
  },
  data() {
    return {
      defaultItem: {
        username: '',
        password: '',
        isAdmin: false,
        isEditor: false,
        isSupervisor: false,
        comment: ''
      },
      editedItem: null,
      rules: [val => (val || '').length > 0 || 'Este campo es requerido'],
    }
  },
  methods: {
    setUserToEdit() {
      this.editedItem = this.itemToEdit ? { ...this.itemToEdit } : { ...this.defaultItem }
      this.resetValidation()
    },
    async onSave() {
      if (this.validate()) {
        this.itemToEdit ? await userService.update(this.editedItem) : await userService.signup(this.editedItem)
        this.resetValidation()
        this.$emit('onClose', true)
      }
    },
    onClose() {
      this.resetValidation()
      this.$emit('onClose')
    },
    validate() {
      return this.$refs.form.validate()
    },
    resetValidation() {
      if (!this.$refs.form) return
      this.$refs.form.resetValidation()
    },
  },
  watch: {
    itemToEdit() {
      this.setUserToEdit()
    }
  }
}

</script>
